export default __webpack_public_path__ + "static/media/part2_title_m.84b07b5b.png";